import { Controller } from "@hotwired/stimulus"
import { navigateFrame } from "../utils/frameNavigation"

// Handles event sorting. Applies through the events_list frame, like the segment
// bar, the filter popovers and the time filter — so sorting keeps the scroll
// position, advances the URL, and identifies itself to
// Events::FilterPersistable as the sort surface. That last part is what lets
// picking the default sort back stick, instead of being read as a bare visit and
// overwritten by the sort that was remembered.
export default class extends Controller {
  static targets = ["select", "directionButton"]
  static values = {
    sortBy: String,
    sortDirection: String,
    frame: { type: String, default: "events_list" }
  }

  updateSort(event) {
    const sortBy = this.selectTarget.value
    const sortDirection = this.sortDirectionValue || 'desc'
    
    this.navigate(sortBy, sortDirection)
  }
  
  toggleDirection(event) {
    event.preventDefault()
    
    const newDirection = this.sortDirectionValue === 'asc' ? 'desc' : 'asc'
    const sortBy = this.sortByValue || 'event_date'
    
    this.navigate(sortBy, newDirection)
  }
  
  // Sort rides on top of whatever is already in the URL, so the active filter is
  // carried through rather than dropped.
  navigate(sortBy, sortDirection) {
    const url = new URL(window.location)
    url.searchParams.set('sort_by', sortBy)
    url.searchParams.set('sort_direction', sortDirection)

    navigateFrame(this.frameValue, url.pathname + url.search)
  }
}

